/**
  * vue-cal v5.0.1-rc.19
  * (c) 2024-2025 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const i = ["Pirmadienis", "Antradienis", "Trečiadienis", "Ketvirtadienis", "Penktadienis", "Šeštadienis", "Sekmadienis"], s = ["Sausis", "Vasaris", "Kovas", "Balandis", "Gegužė", "Birželis", "Liepa", "Rugpjūtis", "Rugsėjis", "Spalis", "Lapkritis", "Gruodis"], t = "Metų pasirinkimas", e = "Metai", n = "Mėnesis", a = "Savaitė", o = "Dienos", d = "Diena", c = "Šiandien", r = "Jokių įvykių", k = "Visa diena", y = "Ištrinti", l = "Sukurti įvykį", u = "dddd, D MMMM YYYY", v = {
  weekDays: i,
  months: s,
  years: t,
  year: e,
  month: n,
  week: a,
  days: o,
  day: d,
  today: c,
  noEvent: r,
  allDay: k,
  deleteEvent: y,
  createEvent: l,
  dateFormat: u
};
export {
  k as allDay,
  l as createEvent,
  u as dateFormat,
  d as day,
  o as days,
  v as default,
  y as deleteEvent,
  n as month,
  s as months,
  r as noEvent,
  c as today,
  a as week,
  i as weekDays,
  e as year,
  t as years
};
